import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetRefundModalities,
	GetRefundModalitiesParams,
	GetRefundModalitiesResponse,
} from 'domain/usecases';

export class RemoteRefundGetModalities implements GetRefundModalities {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetRefundModalitiesResponse>,
	) {}

	async get({signal}: GetRefundModalitiesParams): Promise<GetRefundModalitiesResponse> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
